export const Essentials: { [key: string]: string } = {
  add: '\ue900',
  alert: '\ue901',
  arrow_down_triangle: '\ue902',
  arrow_left_triangle: '\ue903',
  arrow_right_triangle: '\ue904',
  arrow_up_triangle: '\ue905',
  arrows_sort: '\ue916',
  block: '\ue906',
  building_simple: '\ue907',
  cancel: '\ue908',
  check: '\ue909',
  chevron_down: '\ue90a',
  chevron_left: '\ue90b',
  chevron_right: '\ue90c',
  chevron_up: '\ue90d',
  external_link: '\ue90e',
  menu: '\ue90f',
  minus: '\ue910',
  moon: '\ue911',
  question_mark: '\ue912',
  search: '\ue913',
  star_empty: '\ue914',
  star: '\ue915',
};

export const Additional: { [key: string]: string } = {
  d_glasses: '\ue900',
  d_pie_chart: '\ue901',
  d_printing: '\ue902',
  x4: '\ue903',
  '360': '\ue904',
  'a-_blood_type': '\ue905',
  a_blood_type: '\ue906',
  'ab-_blood_type': '\ue907',
  ab_blood_type: '\ue908',
  ac: '\ue909',
  accordion: '\ue90a',
  ace_clubs: '\ue90b',
  ace_diamonds: '\ue90c',
  ace_hearts: '\ue90d',
  ace_spades: '\ue90e',
  add_circle: '\ue90f',
  add_love_heart: '\ue910',
  add_music_album: '\ue911',
  add_network: '\ue912',
  add_sd_card: '\ue913',
  add_server: '\ue914',
  add_shopping_cart: '\ue915',
  adult: '\ue916',
  ai_file: '\ue917',
  air_hockey: '\ue918',
  air_pump: '\ue919',
  airdrop: '\ue91a',
  alarm_clock: '\ue91b',
  alcoholic_beverage: '\ue91c',
  alert_circle: '\ue91d',
  alien_space_ship_illuminated: '\ue91e',
  alien_spaceship: '\ue91f',
  alien: '\ue920',
  align_center: '\ue921',
  align_justify_center: '\ue922',
  align_justify_left: '\ue923',
  align_justify_right: '\ue924',
  align_justify: '\ue925',
  align_left: '\ue926',
  align_right: '\ue927',
  align: '\ue928',
  all_seeing_eye: '\ue929',
  alphabet_blocks: '\ue92a',
  ambulance: '\ue92b',
  analyzing_results: '\ue92c',
  anchor: '\ue92d',
  angel_heart: '\ue92e',
  announcement_email: '\ue92f',
  announcement_smile: '\ue930',
  announcement: '\ue931',
  apartment_building: '\ue932',
  apple_and_book: '\ue933',
  apple_clipboard: '\ue934',
  apple_measuring_tape: '\ue935',
  apple_watch: '\ue936',
  apple: '\ue937',
  apron: '\ue938',
  aquarius: '\ue939',
  architectural: '\ue93a',
  architecture_ruler_tool: '\ue93b',
  architecture: '\ue93c',
  archive: '\ue93d',
  area_space_circle: '\ue93e',
  aries: '\ue93f',
  armchair: '\ue940',
  arrival: '\ue941',
  arrow_down_left_up_right: '\ue942',
  arrow_down_left: '\ue943',
  arrow_down_right: '\ue944',
  arrow_down_server: '\ue945',
  arrow_left_right: '\ue946',
  arrow_up_down: '\ue947',
  arrow_up_left_down_right: '\ue948',
  arrow_up_left: '\ue949',
  arrow_up_right: '\ue94a',
  arrow_up_server: '\ue94b',
  arrows_down_left_up_right_line_seperating: '\ue94c',
  arrows_down_left_up_right: '\ue94d',
  arrows_left_right_line_seperating: '\ue94e',
  arrows_left_right: '\ue94f',
  arrows_lines_meeting_left_right: '\ue950',
  arrows_lines_meeting_up_down: '\ue951',
  arrows_lines_seperating_up_down: '\ue952',
  arrows_seperating_lines_left_right: '\ue953',
  arrows_u_turn_left: '\ue954',
  arrows_u_turn_right: '\ue955',
  arrows_u_turn_up: '\ue956',
  arrows_up_down_line_seperating: '\ue957',
  arrows_up_down: '\ue958',
  arrows_up_left_down_right_line_seperating: '\ue959',
  arrows_up_left_down_right: '\ue95a',
  article_sign: '\ue95b',
  asparagus: '\ue95c',
  at: '\ue95d',
  atm: '\ue95e',
  atoms: '\ue95f',
  audio_file: '\ue960',
  avi_file: '\ue961',
  award: '\ue962',
  axe: '\ue963',
  'b-_blood_type': '\ue964',
  b_blood_type: '\ue965',
  backpack: '\ue966',
  badge: '\ue967',
  badminton: '\ue968',
  bag_transfer: '\ue969',
  bamboo_flute: '\ue96a',
  bananas: '\ue96b',
  band_aid: '\ue96c',
  bar_chart_increase: '\ue96d',
  bar_charts: '\ue96e',
  bar_code: '\ue96f',
  bar_line_chart: '\ue970',
  barn: '\ue971',
  bars_chart_decrease: '\ue972',
  base_clef_music_note: '\ue973',
  baseball: '\ue974',
  basketball_net: '\ue975',
  basketball_sports: '\ue976',
  basketball: '\ue977',
  bath_amenities: '\ue978',
  bathtub: '\ue979',
  battery_charging: '\ue97a',
  battery_full: '\ue97b',
  battery_low: '\ue97c',
  battery: '\ue97d',
  bbq_grill: '\ue97e',
  bbq_tools: '\ue97f',
  bbq: '\ue980',
  bcd: '\ue981',
  beach_ball: '\ue982',
  beach_vacation: '\ue983',
  beans: '\ue984',
  bear: '\ue985',
  bed: '\ue986',
  bee: '\ue987',
  beer_glass: '\ue988',
  beer_high_glass: '\ue989',
  beer_jug: '\ue98a',
  beer: '\ue98b',
  behance: '\ue98c',
  belt: '\ue98d',
  bench: '\ue98e',
  bible: '\ue98f',
  big_eyed_monster: '\ue990',
  bike: '\ue991',
  billboard: '\ue992',
  billiards: '\ue993',
  bin: '\ue994',
  binoculars: '\ue995',
  bird: '\ue996',
  birds: '\ue997',
  birthday_cake_slice: '\ue998',
  bitcoin_coi: '\ue999',
  bitcoin_sign: '\ue99a',
  blackboard: '\ue99b',
  blank_open_book: '\ue99c',
  blender: '\ue99d',
  block_circle: '\ue99e',
  block_credit_card: '\ue99f',
  blood_bag: '\ue9a0',
  bluetooth: '\ue9a1',
  bmp: '\ue9a2',
  boat_length: '\ue9a3',
  boat_speed: '\ue9a4',
  boat: '\ue9a5',
  body_lotion: '\ue9a6',
  body_splash_perfume: '\ue9a7',
  bold: '\ue9a8',
  bolt: '\ue9a9',
  bomb: '\ue9aa',
  bone_bowl: '\ue9ab',
  bone: '\ue9ac',
  book: '\ue9ad',
  bookcase: '\ue9ae',
  booking_online: '\ue9af',
  bookmark_credit_card: '\ue9b0',
  bookmark_favourite_mobile_phone: '\ue9b1',
  bookmark_favourite_sd_card: '\ue9b2',
  bookmark_favourite_storage: '\ue9b3',
  bookmark_house: '\ue9b4',
  bookmark_music_album: '\ue9b5',
  bookmark_paper_aeroplane: '\ue9b6',
  bookmark_star_circle: '\ue9b7',
  bookmark_webpage: '\ue9b8',
  bookmark: '\ue9b9',
  bottle: '\ue9ba',
  boulder: '\ue9bb',
  bow_tie: '\ue9bc',
  bowling_ball_and_pins: '\ue9bd',
  bowling: '\ue9be',
  boxers: '\ue9bf',
  boxing: '\ue9c0',
  brandy_bottle_and_glass: '\ue9c1',
  brandy_bottle: '\ue9c2',
  brandy_glass: '\ue9c3',
  bread: '\ue9c4',
  breakfast_tea_and_croissant: '\ue9c5',
  bridge: '\ue9c6',
  british_pound_coin: '\ue9c7',
  british_pound_sign: '\ue9c8',
  'broken-heart': '\ue9c9',
  'broken-link': '\ue9ca',
  broom: '\ue9cb',
  bubbles: '\ue9cc',
  bug: '\ue9cd',
  bullseye_target: '\ue9ce',
  bullseye: '\ue9cf',
  burger: '\ue9d0',
  'bus-front-view-transportation': '\ue9d1',
  bus: '\ue9d2',
  bush: '\ue9d3',
  butler: '\ue9d4',
  butterfly: '\ue9d5',
  button: '\ue9d6',
  cableway_lift: '\ue9d7',
  cactus: '\ue9d8',
  cage: '\ue9d9',
  cake_slice: '\ue9da',
  cake: '\ue9db',
  calculations: '\ue9dc',
  calculator_simple: '\ue9dd',
  calculator: '\ue9de',
  calender: '\ue9df',
  call_service: '\ue9e0',
  call_smart_watch: '\ue9e1',
  camera_back: '\ue9e2',
  camera: '\ue9e3',
  camp_fire: '\ue9e4',
  camper: '\ue9e5',
  camping_tent_night_moon: '\ue9e6',
  camping_tent: '\ue9e7',
  cancel_call: '\ue9e8',
  cancel_circle: '\ue9e9',
  cancel_employee: '\ue9ea',
  cancel_network: '\ue9eb',
  cancel_sd_card: '\ue9ec',
  cancel_server: '\ue9ed',
  cancel_shopping_cart: '\ue9ee',
  cancer: '\ue9ef',
  candle: '\ue9f0',
  candy_cane: '\ue9f1',
  candy: '\ue9f2',
  cap: '\ue9f3',
  capital: '\ue9f4',
  capricorn: '\ue9f5',
  car_battery: '\ue9f6',
  car_electric: '\ue9f7',
  car_exchange: '\ue9f8',
  car_front: '\ue9f9',
  car_gift: '\ue9fa',
  car_key: '\ue9fb',
  car_locked: '\ue9fc',
  car_maintenance: '\ue9fd',
  car_new: '\ue9fe',
  car_search: '\ue9ff',
  car_wash: '\uea00',
  car: '\uea01',
  caravan: '\uea02',
  carrot: '\uea03',
  cart: '\uea04',
  cash_credit_card: '\uea05',
  cash_register: '\uea06',
  cassette_tape: '\uea07',
  castle: '\uea08',
  cat: '\uea09',
  cc_circle: '\uea0a',
  cd_dvd_disk: '\uea0b',
  cd: '\uea0c',
  celcius: '\uea0d',
  cells: '\uea0e',
  certificate_badge: '\uea0f',
  certificate: '\uea10',
  champagne_cooling: '\uea11',
  champagne: '\uea12',
  chart_presentation: '\uea13',
  cheese: '\uea14',
  chef_hat_moustache: '\uea15',
  chef_hat: '\uea16',
  chef: '\uea17',
  cheque: '\uea18',
  cherries: '\uea19',
  chicken_leg: '\uea1a',
  chinese_food: '\uea1b',
  chocolate: '\uea1c',
  christmas_tree_large: '\uea1d',
  christmas_tree_small: '\uea1e',
  circus_tent: '\uea1f',
  click_target: '\uea20',
  clipboard_checklist: '\uea21',
  clipboard: '\uea22',
  clock_rotate: '\uea23',
  clock_tower: '\uea24',
  closed_envelope: '\uea25',
  clothes_hanger: '\uea26',
  cloud_add: '\uea27',
  cloud_alert: '\uea28',
  cloud_block: '\uea29',
  cloud_call: '\uea2a',
  cloud_cancel: '\uea2b',
  cloud_confirm: '\uea2c',
  cloud_delete: '\uea2d',
  cloud_download: '\uea2e',
  cloud_image: '\uea2f',
  cloud_large: '\uea30',
  cloud_lightening_rain_storm: '\uea31',
  cloud_lightening_storm: '\uea32',
  cloud_mobile: '\uea33',
  cloud_music: '\uea34',
  cloud_question: '\uea35',
  cloud_rain: '\uea36',
  cloud_refresh: '\uea37',
  cloud_search: '\uea38',
  cloud_security: '\uea39',
  cloud_settings: '\uea3a',
  cloud_share: '\uea3b',
  cloud_small: '\uea3c',
  cloud_snow_simple: '\uea3d',
  cloud_snow: '\uea3e',
  cloud_transfer: '\uea3f',
  cloud_upload: '\uea40',
  cloud_video: '\uea41',
  cloud_wireless: '\uea42',
  cloud: '\uea43',
  clouds_small: '\uea44',
  clouds: '\uea45',
  clubs: '\uea46',
  cmyk: '\uea47',
  cocktail: '\uea48',
  coconut: '\uea49',
  coding_programming: '\uea4a',
  coffee_tea: '\uea4b',
  coffee_with_beans: '\uea4c',
  coffee: '\uea4d',
  coin_exchange: '\uea4e',
  coins: '\uea4f',
  color_swatches: '\uea50',
  comb: '\uea51',
  communication_satellite: '\uea52',
  communication: '\uea53',
  compact_camera: '\uea54',
  compass_tool: '\uea55',
  compass: '\uea56',
  computer_screen_apple: '\uea57',
  computer_screen_connection_port: '\uea58',
  computer_screen_mobile_phone_compatible: '\uea59',
  computer_screen_statistics_chart: '\uea5a',
  computer_storage: '\uea5b',
  condom: '\uea5c',
  cone_ice_cream: '\uea5d',
  confirm_circle: '\uea5e',
  confirm_clipboard: '\uea5f',
  confirm_employee: '\uea60',
  confirm_love_heart: '\uea61',
  confirm_network: '\uea62',
  confirm_sd_card: '\uea63',
  confirm_security: '\uea64',
  confirm_server: '\uea65',
  confirm_square_text: '\uea66',
  confirm_text: '\uea67',
  confirmed_security_computer: '\uea68',
  construction_crane: '\uea69',
  conversion_funnel: '\uea6a',
  cook_book: '\uea6b',
  copy_right_circle: '\uea6c',
  county_select: '\uea6d',
  coupon: '\uea6e',
  cow: '\uea6f',
  cpu: '\uea70',
  crab: '\uea71',
  crane: '\uea72',
  crate_cancel: '\uea73',
  crate_confirm: '\uea74',
  crate_extract: '\uea75',
  crate_insert: '\uea76',
  crate_move_down: '\uea77',
  crate_move_up: '\uea78',
  crate_open: '\uea79',
  crate_right_way_up: '\uea7a',
  crate_security: '\uea7b',
  crate_time: '\uea7c',
  crate: '\uea7d',
  crayon: '\uea7e',
  credit_card_international: '\uea7f',
  credit_card: '\uea80',
  credit_machine: '\uea81',
  croissant: '\uea82',
  crop: '\uea83',
  crown_large: '\uea84',
  crown_queen: '\uea85',
  crown_simple: '\uea86',
  crown_small: '\uea87',
  crown: '\uea88',
  cupboard: '\uea89',
  cupcake_cherry: '\uea8a',
  cupcake_love: '\uea8b',
  cupcake_smile: '\uea8c',
  cupcake: '\uea8d',
  cupid_bow: '\uea8e',
  cupid: '\uea8f',
  cursor_click: '\uea90',
  cursor_move: '\uea91',
  cursor_waiting: '\uea92',
  cursor: '\uea93',
  customer_needs_help: '\uea94',
  customer_service_text: '\uea95',
  cutlery: '\uea96',
  dead_flower: '\uea97',
  delete_circle: '\uea98',
  delete_love_heart: '\uea99',
  delete_music_album: '\uea9a',
  delete_network: '\uea9b',
  delete_sd_card: '\uea9c',
  delete_shopping_cart: '\uea9d',
  departure: '\uea9e',
  depth: '\uea9f',
  desk_lamp: '\ueaa0',
  desk: '\ueaa1',
  destination_globe: '\ueaa2',
  destination_map: '\ueaa3',
  deviantart: '\ueaa4',
  devil_love: '\ueaa5',
  diamond_ring: '\ueaa6',
  diamond: '\ueaa7',
  diamonds: '\ueaa8',
  dice: '\ueaa9',
  digital_lock_locked: '\ueaaa',
  digital_lock_unlocked: '\ueaab',
  dimensional_double_bed: '\ueaac',
  direction_signs: '\ueaad',
  directions: '\ueaae',
  director_chair: '\ueaaf',
  disable_notifications: '\ueab0',
  disabled_access: '\ueab1',
  discount_sticker: '\ueab2',
  discount_tag: '\ueab3',
  dislike: '\ueab4',
  dive_center: '\ueab5',
  divesite: '\ueab6',
  divided_pie_chart: '\ueab7',
  diving_flippers: '\ueab8',
  diving_goggles: '\ueab9',
  diving_presentation: '\ueaba',
  diving: '\ueabb',
  dj_turn_table: '\ueabc',
  dna: '\ueabd',
  doc: '\ueabe',
  document_alert: '\ueabf',
  document_blank: '\ueac0',
  document_bookmark: '\ueac1',
  document_cancel: '\ueac2',
  document_confirm: '\ueac3',
  document_download: '\ueac4',
  document_edit: '\ueac5',
  document_envelope: '\ueac6',
  document_error: '\ueac7',
  document_pie_chart: '\ueac8',
  document_question: '\ueac9',
  document_recycle: '\ueaca',
  document_refresh: '\ueacb',
  document_sound: '\ueacc',
  document_text: '\ueacd',
  document_upload: '\ueace',
  dog: '\ueacf',
  dollar_badge: '\uead0',
  dollar_coin: '\uead1',
  dome: '\uead2',
  dominos: '\uead3',
  dont_disturb: '\uead4',
  donut_top_bite: '\uead5',
  donut_top: '\uead6',
  donut: '\uead7',
  door_open: '\uead8',
  door: '\uead9',
  dots_bullet_points: '\ueada',
  double_paper_tray: '\ueadb',
  double_pointers_line_down: '\ueadc',
  double_pointers_line_left: '\ueadd',
  double_pointers_line_right: '\ueade',
  double_pointers_line_up: '\ueadf',
  double_room: '\ueae0',
  double_rotate: '\ueae1',
  double_tab: '\ueae2',
  doubletap_finger: '\ueae3',
  down_shopping_cart: '\ueae4',
  down: '\ueae5',
  download_arrow_down_music_album: '\ueae6',
  download: '\ueae7',
  drag_down: '\ueae8',
  drag_left: '\ueae9',
  drag_right: '\ueaea',
  drag_up: '\ueaeb',
  drag: '\ueaec',
  drawing: '\ueaed',
  dribble: '\ueaee',
  drill: '\ueaef',
  dropbox: '\ueaf0',
  drugstore: '\ueaf1',
  drums: '\ueaf2',
  dvd_player: '\ueaf3',
  dynamite: '\ueaf4',
  ear_pugs: '\ueaf5',
  earrings: '\ueaf6',
  egg: '\ueaf7',
  egyptian_symbol: '\ueaf8',
  eiffel_tower: '\ueaf9',
  eject: '\ueafa',
  electric_car: '\ueafb',
  electric_guitar: '\ueafc',
  electric_vehicle_fuel: '\ueafd',
  electrical_saw: '\ueafe',
  electricity_green_leaf: '\ueaff',
  electricity_plug: '\ueb00',
  electricity: '\ueb01',
  electronic_drawing: '\ueb02',
  elevator: '\ueb03',
  emoticon: '\ueb04',
  energy_drink: '\ueb05',
  energy_substance: '\ueb06',
  engagement_ring: '\ueb07',
  eps: '\ueb08',
  eraser_tool: '\ueb09',
  eraser: '\ueb0a',
  error_lethal_virus_computer: '\ueb0b',
  eskimo: '\ueb0c',
  espresso_machine: '\ueb0d',
  euro_coin: '\ueb0e',
  euro_sign: '\ueb0f',
  exe: '\ueb10',
  expand_horizontal: '\ueb11',
  expand_vertical: '\ueb12',
  expand: '\ueb13',
  explosion: '\ueb14',
  export: '\ueb15',
  express: '\ueb16',
  eyedropper: '\ueb17',
  eyes_glasses: '\ueb18',
  facebook: '\ueb19',
  factory: '\ueb1a',
  fahrenheit: '\ueb1b',
  fan: '\ueb1c',
  fast_forward: '\ueb1d',
  fast_shipping: '\ueb1e',
  favourite_house: '\ueb1f',
  favourite_rack: '\ueb20',
  favourite_webpage: '\ueb21',
  female_marriage: '\ueb22',
  female: '\ueb23',
  fence: '\ueb24',
  filled_pencil_book_writing: '\ueb25',
  filled_pencil_writing: '\ueb26',
  film: '\ueb27',
  finger_print: '\ueb28',
  fire_alarm: '\ueb29',
  fire_extinguisher: '\ueb2a',
  fire_house: '\ueb2b',
  fire_hydrant: '\ueb2c',
  fireman_helmet: '\ueb2d',
  firewall: '\ueb2e',
  first_line_indent: '\ueb2f',
  first_place_medal: '\ueb30',
  fish_bowl: '\ueb31',
  fish_hat: '\ueb32',
  fish: '\ueb33',
  five_stars: '\ueb34',
  flag_country: '\ueb35',
  flag: '\ueb36',
  flame_settings: '\ueb37',
  flash: '\ueb38',
  flashlight: '\ueb39',
  flat_screen_tv: '\ueb3a',
  flickr: '\ueb3b',
  flying_oragamy_bird: '\ueb3c',
  flying_rocket: '\ueb3d',
  focus_length: '\ueb3e',
  folder_add: '\ueb3f',
  folder_bookmark: '\ueb40',
  folder_closed: '\ueb41',
  folder_delete: '\ueb42',
  folder_download: '\ueb43',
  folder_edit: '\ueb44',
  folder_images: '\ueb45',
  folder_locked: '\ueb46',
  folder_music: '\ueb47',
  folder_open: '\ueb48',
  folder_refresh: '\ueb49',
  folder_search: '\ueb4a',
  folder_share: '\ueb4b',
  folder_unlocked: '\ueb4c',
  folder_upload: '\ueb4d',
  folder_videos: '\ueb4e',
  folder_zipped: '\ueb4f',
  food_stand: '\ueb50',
  football_statistics_rise: '\ueb51',
  football: '\ueb52',
  for_sale: '\ueb53',
  forklift: '\ueb54',
  formal_dress: '\ueb55',
  fountain: '\ueb56',
  fragile: '\ueb57',
  fries: '\ueb58',
  frog: '\ueb59',
  front_desk: '\ueb5a',
  full_view: '\ueb5b',
  gambling_dice_playing_cards: '\ueb5c',
  game_controller: '\ueb5d',
  garage_car: '\ueb5e',
  garage: '\ueb5f',
  gas_station: '\ueb60',
  gavel_hammer_justice: '\ueb61',
  gavel: '\ueb62',
  gemini: '\ueb63',
  ghost: '\ueb64',
  gif: '\ueb65',
  gift_heart: '\ueb66',
  gift_wrapped_heart_love: '\ueb67',
  gift: '\ueb68',
  glass_of_milk_and_carton: '\ueb69',
  glass_of_milk: '\ueb6a',
  glasses_hat: '\ueb6b',
  glasses: '\ueb6c',
  global_book: '\ueb6d',
  global_education: '\ueb6e',
  global_renewable_power: '\ueb6f',
  global_security: '\ueb70',
  global_warming: '\ueb71',
  globe_earth: '\ueb72',
  globe_hand: '\ueb73',
  globe_place: '\ueb74',
  globe_rounded: '\ueb75',
  globe_search: '\ueb76',
  globe_select: '\ueb77',
  globe_stand: '\ueb78',
  globe: '\ueb79',
  gloves: '\ueb7a',
  go_pro: '\ueb7b',
  goal: '\ueb7c',
  gold: '\ueb7d',
  goldfish: '\ueb7e',
  google_plus: '\ueb7f',
  gorilla: '\ueb80',
  graduation_hat: '\ueb81',
  gramaphone: '\ueb82',
  graphic_tool_artboard: '\ueb83',
  grass: '\ueb84',
  grater: '\ueb85',
  green_energy_earth: '\ueb86',
  green_factory: '\ueb87',
  green_house: '\ueb88',
  green_power_earth: '\ueb89',
  green_power: '\ueb8a',
  green_tag: '\ueb8b',
  green_vehicle_fuel: '\ueb8c',
  group_one: '\ueb8d',
  group_three: '\ueb8e',
  group_two: '\ueb8f',
  grow_money: '\ueb90',
  growing_love: '\ueb91',
  guitar: '\ueb92',
  gun: '\ueb93',
  gym: '\ueb94',
  hair_dryer: '\ueb95',
  hammer: '\ueb96',
  hamster: '\ueb97',
  hand_delivery: '\ueb98',
  hand_key: '\ueb99',
  hand_saw: '\ueb9a',
  hand_soap: '\ueb9b',
  handcuffs: '\ueb9c',
  handheld_game_controller: '\ueb9d',
  handheld_video_camera: '\ueb9e',
  harmonica: '\ueb9f',
  harp: '\ueba0',
  hat: '\ueba1',
  headhunt: '\ueba2',
  headphones: '\ueba3',
  headset_smile: '\ueba4',
  headset: '\ueba5',
  heart_balloons: '\ueba6',
  heart_glasses: '\ueba7',
  heart_lock: '\ueba8',
  heart: '\ueba9',
  heartbeat: '\uebaa',
  hearts_love: '\uebab',
  hearts: '\uebac',
  heating: '\uebad',
  heeled_woman_boot: '\uebae',
  helicopter_emergency: '\uebaf',
  helicopter: '\uebb0',
  herbal_medicine_box_aid: '\uebb1',
  herbal: '\uebb2',
  hierarchy: '\uebb3',
  hightops_shoe: '\uebb4',
  hold: '\uebb5',
  home_flood: '\uebb6',
  home: '\uebb7',
  honey_jar: '\uebb8',
  horse_shoe: '\uebb9',
  hospital_sign: '\uebba',
  hospital: '\uebbb',
  hot_air_balloon_cloud_transportation: '\uebbc',
  hot_air_balloon_launch_laptop: '\uebbd',
  hot_air_balloon: '\uebbe',
  hot_beverage_view: '\uebbf',
  hot_meal: '\uebc0',
  hotdog: '\uebc1',
  hourglass: '\uebc2',
  house_fire: '\uebc3',
  house: '\uebc4',
  hover: '\uebc5',
  html_five: '\uebc6',
  html: '\uebc7',
  hunting_love: '\uebc8',
  hurricane_tornado: '\uebc9',
  hut: '\uebca',
  ice_cap_short: '\uebcb',
  ice_cap_winter: '\uebcc',
  ice_cap: '\uebcd',
  ice_cream_bowl: '\uebce',
  ice_cream_cone_three: '\uebcf',
  ice_cream_cone: '\uebd0',
  ice_cream: '\uebd1',
  id_card: '\uebd2',
  idea_search: '\uebd3',
  illuminated_mountain_tops: '\uebd4',
  illuminated_open_book: '\uebd5',
  illuminated_pencil: '\uebd6',
  illuminated_personal_open_book: '\uebd7',
  image_gallery_straight: '\uebd8',
  image_gallery: '\uebd9',
  image_message: '\uebda',
  image_polaroid: '\uebdb',
  image: '\uebdc',
  images: '\uebdd',
  import: '\uebde',
  incoming_call: '\uebdf',
  incoming: '\uebe0',
  indent_left_margin: '\uebe1',
  indent_right_margin: '\uebe2',
  indoor_pool: '\uebe3',
  infinity_symbol: '\uebe4',
  info_bold: '\uebe5',
  info: '\uebe6',
  inline: '\uebe7',
  innovation_lightbulb: '\uebe8',
  instagram: '\uebe9',
  international_calls: '\uebea',
  international_sky_travel: '\uebeb',
  international_socket: '\uebec',
  ipod_dock: '\uebed',
  ipod_music: '\uebee',
  ipod: '\uebef',
  iron: '\uebf0',
  ironing_board: '\uebf1',
  island_palm: '\uebf2',
  italic: '\uebf3',
  jack_in_the_box: '\uebf4',
  jam: '\uebf5',
  jelly: '\uebf6',
  jellyfish: '\uebf7',
  jpg: '\uebf8',
  juice: '\uebf9',
  juicer: '\uebfa',
  kayaking: '\uebfb',
  ketchup: '\uebfc',
  kettle: '\uebfd',
  kettlebell: '\uebfe',
  key_music_note: '\uebff',
  key_rounded: '\uec00',
  key_square: '\uec01',
  key: '\uec02',
  keyboard: '\uec03',
  keyhole: '\uec04',
  kiosk: '\uec05',
  kitchen_chef: '\uec06',
  kite_surfing_water: '\uec07',
  kite_surfing: '\uec08',
  kite: '\uec09',
  kitten: '\uec0a',
  knife_fork: '\uec0b',
  knife: '\uec0c',
  knitting: '\uec0d',
  ladder: '\uec0e',
  lamp: '\uec0f',
  laptop_sitting_view: '\uec10',
  laptop: '\uec11',
  large_building_tower: '\uec12',
  large_building: '\uec13',
  large_factory: '\uec14',
  large_garage: '\uec15',
  large_planet: '\uec16',
  large_tower: '\uec17',
  large_video_camera: '\uec18',
  lasso_tool: '\uec19',
  launching_rocket: '\uec1a',
  law_building_flat_roof: '\uec1b',
  law_building: '\uec1c',
  leaf_falling: '\uec1d',
  leaf_green_water: '\uec1e',
  leaf_hands: '\uec1f',
  leaf: '\uec20',
  learning: '\uec21',
  left_right: '\uec22',
  left: '\uec23',
  lemon: '\uec24',
  lemonade: '\uec25',
  lens: '\uec26',
  leo: '\uec27',
  libra: '\uec28',
  library: '\uec29',
  life_jacket: '\uec2a',
  life_preserver: '\uec2b',
  light_bulb: '\uec2c',
  lightbulb_clipboard: '\uec2d',
  lightbulb: '\uec2e',
  lightening_lightbulb: '\uec2f',
  lightening_thought: '\uec30',
  lightening_trophy: '\uec31',
  lightening: '\uec32',
  lighter: '\uec33',
  lighthouse: '\uec34',
  like_and_comment: '\uec35',
  like_comment: '\uec36',
  like_computer_screen: '\uec37',
  like_female_profile: '\uec38',
  like_laptop: '\uec39',
  like_male_profile: '\uec3a',
  like_mobile_phone: '\uec3b',
  like: '\uec3c',
  limousine: '\uec3d',
  line_chart: '\uec3e',
  lingerie: '\uec3f',
  link: '\uec40',
  linkedin: '\uec41',
  lion: '\uec42',
  lips_love_conversation: '\uec43',
  lips: '\uec44',
  lipstick: '\uec45',
  listening_to_music: '\uec46',
  lit_barbeque: '\uec47',
  loading_circle: '\uec48',
  loading_text: '\uec49',
  loading_webpage: '\uec4a',
  location_navigation_mobile_phone: '\uec4b',
  location_pointer_map: '\uec4c',
  location: '\uec4d',
  lock_sd_card: '\uec4e',
  lock_server: '\uec4f',
  lock_storage: '\uec50',
  lock: '\uec51',
  locked_circle: '\uec52',
  locked_mobile_phone: '\uec53',
  locked_network: '\uec54',
  locked_webpage: '\uec55',
  log: '\uec56',
  lollipop: '\uec57',
  london_eye: '\uec58',
  lotus: '\uec59',
  loud_announcement: '\uec5a',
  love_chat_conversation: '\uec5b',
  love_chat: '\uec5c',
  love_chemistry: '\uec5d',
  love_food: '\uec5e',
  love_heart_hot_drink: '\uec5f',
  love_letter: '\uec60',
  love_message: '\uec61',
  low_volume: '\uec62',
  lucky_clover_dice: '\uec63',
  lucky_clover: '\uec64',
  luggage_baggage: '\uec65',
  macro: '\uec66',
  magic_hat: '\uec67',
  magic_wand: '\uec68',
  magnet: '\uec69',
  maid: '\uec6a',
  mailbox: '\uec6b',
  making_herbal_medicine: '\uec6c',
  male_marriage: '\uec6d',
  male: '\uec6e',
  man_add: '\uec6f',
  man_alert: '\uec70',
  man_block: '\uec71',
  man_bookmark: '\uec72',
  man_cancel: '\uec73',
  man_confirm: '\uec74',
  man_delete: '\uec75',
  man_duplicate: '\uec76',
  man_favourite: '\uec77',
  man_settings: '\uec78',
  man_upper_body: '\uec79',
  man_view: '\uec7a',
  man_woman: '\uec7b',
  man: '\uec7c',
  mandolin: '\uec7d',
  map_search: '\uec7e',
  map: '\uec7f',
  maracas: '\uec80',
  marker: '\uec81',
  marriage_ceremony_alter: '\uec82',
  marriage_rings: '\uec83',
  marriage: '\uec84',
  mask: '\uec85',
  maximize_font: '\uec86',
  maximize: '\uec87',
  meal: '\uec88',
  measuring_tape: '\uec89',
  meat: '\uec8a',
  medal: '\uec8b',
  medical_bag: '\uec8c',
  medical_cabinet: '\uec8d',
  medical_chart: '\uec8e',
  medical_emergency: '\uec8f',
  medicine_bottle_pill_medical: '\uec90',
  medium_volume: '\uec91',
  meeting: '\uec92',
  message_arrow_down: '\uec93',
  message_block: '\uec94',
  message_cancel: '\uec95',
  message_confirm: '\uec96',
  message_favourite: '\uec97',
  message_question: '\uec98',
  message_security: '\uec99',
  message_settings: '\uec9a',
  message_smart_phone: '\uec9b',
  messaging: '\uec9c',
  meteor: '\uec9d',
  'microphone-03': '\uec9e',
  'microphone-12': '\uec9f',
  microscope: '\ueca0',
  microwave: '\ueca1',
  milk_carton: '\ueca2',
  mini_fridge: '\ueca3',
  minimize_fonts: '\ueca4',
  minimize: '\ueca5',
  mirror: '\ueca6',
  missile: '\ueca7',
  mist_sunny: '\ueca8',
  mixer_sound: '\ueca9',
  mixer: '\uecaa',
  mobile_message: '\uecab',
  mobile_phone_lock: '\uecac',
  mobile_phone_responsive_touch_screen: '\uecad',
  mobile_phone_security: '\uecae',
  mobile_phone_wifi: '\uecaf',
  mobile_shopping: '\uecb0',
  mobile: '\uecb1',
  modernroom_office_telephoneroom_reception_telephone: '\uecb2',
  money_bag: '\uecb3',
  money_chat_bubbel: '\uecb4',
  money_exchange: '\uecb5',
  money_hand: '\uecb6',
  money_hands: '\uecb7',
  monkey: '\uecb8',
  moon_and_stars: '\uecb9',
  moon_round: '\uecba',
  moon_sleeping: '\uecbb',
  mopad_front: '\uecbc',
  mopad: '\uecbd',
  mosque: '\uecbe',
  mountain: '\uecbf',
  mouse_computer_technology: '\uecc0',
  mouse: '\uecc1',
  moustache: '\uecc2',
  mov: '\uecc3',
  move_left_finger: '\uecc4',
  move_right_finger: '\uecc5',
  movie_night_pop_corn: '\uecc6',
  movie_reel: '\uecc7',
  movies: '\uecc8',
  mushroom: '\uecc9',
  music_album_selection: '\uecca',
  music_album: '\ueccb',
  music_cd: '\ueccc',
  music_library: '\ueccd',
  music_storage: '\uecce',
  music: '\ueccf',
  musical_triangle: '\uecd0',
  mute_notification_bell: '\uecd1',
  mute: '\uecd2',
  necklace: '\uecd3',
  new_employee: '\uecd4',
  new_shopping_cart: '\uecd5',
  newspaper: '\uecd6',
  next: '\uecd7',
  night_clear: '\uecd8',
  night_moon_clouds: '\uecd9',
  no_junk_food: '\uecda',
  no_smoking: '\uecdb',
  no_sound: '\uecdc',
  not_visible: '\uecdd',
  notification_battery_alert: '\uecde',
  notification_bell: '\uecdf',
  notification_square_text: '\uece0',
  notification_text: '\uece1',
  nuclear: '\uece2',
  numbered: '\uece3',
  nurse: '\uece4',
  'o-_blood_type': '\uece5',
  o_blood_type: '\uece6',
  oak_tree: '\uece7',
  ocean: '\uece8',
  octopus: '\uece9',
  oil_gallon: '\uecea',
  old_fashioned_computer_pc: '\ueceb',
  old_testament: '\uecec',
  one_eighth_music_note: '\ueced',
  one_fourth_music_note: '\uecee',
  'one-handled_shopping_basket': '\uecef',
  online_dating: '\uecf0',
  online_education: '\uecf1',
  online_shopping: '\uecf2',
  open_bag: '\uecf3',
  open_envelope: '\uecf4',
  organic_food: '\uecf5',
  oud: '\uecf6',
  outgoing_call: '\uecf7',
  outgoing: '\uecf8',
  oven: '\uecf9',
  overlap_chart: '\uecfa',
  overlap_line_chart: '\uecfb',
  owl: '\uecfc',
  paint_brush: '\uecfd',
  paint_bucket: '\uecfe',
  palm_tree: '\uecff',
  panda: '\ued00',
  panflute: '\ued01',
  pants: '\ued02',
  paper_aeroplane: '\ued03',
  paper_tray_full: '\ued04',
  paper_tray: '\ued05',
  papers_paperclip: '\ued06',
  paprika: '\ued07',
  paragraph_alignment_indent: '\ued08',
  paragraph_alignment_straight: '\ued09',
  paragraph: '\ued0a',
  park_tree: '\ued0b',
  parking: '\ued0c',
  partly_sunny: '\ued0d',
  party: '\ued0e',
  passport_international: '\ued0f',
  passport: '\ued10',
  path_tool: '\ued11',
  path: '\ued12',
  pause_call: '\ued13',
  'pause_movie_video_camera-42': '\ued14',
  pause_movie: '\ued15',
  pause: '\ued16',
  paw: '\ued17',
  paypal: '\ued18',
  pc_computer: '\ued19',
  pdf: '\ued1a',
  peace_sign_settings: '\ued1b',
  peace_sign_van: '\ued1c',
  peace_sign: '\ued1d',
  peace_symbol: '\ued1e',
  pear: '\ued1f',
  pearl_sea_shell: '\ued20',
  pen_icon: '\ued21',
  pen_open_book: '\ued22',
  pencil_case: '\ued23',
  pencil: '\ued24',
  percentage_pie_chart: '\ued25',
  percentage: '\ued26',
  percussion: '\ued27',
  performance: '\ued28',
  personal_account_circle: '\ued29',
  pets: '\ued2a',
  pharaoh_eye: '\ued2b',
  phone_ringing: '\ued2c',
  phone: '\ued2d',
  photography_light: '\ued2e',
  piano: '\ued2f',
  pick_up_truck: '\ued30',
  picture_hangning: '\ued31',
  pictures: '\ued32',
  pie_chart: '\ued33',
  pie_tool: '\ued34',
  pig: '\ued35',
  piggy_bank: '\ued36',
  pill_new: '\ued37',
  pill: '\ued38',
  pillar: '\ued39',
  pills_bottle: '\ued3a',
  pills_different: '\ued3b',
  pills_pack: '\ued3c',
  pills_two: '\ued3d',
  pin: '\ued3e',
  pine_tree: '\ued3f',
  pineapple: '\ued40',
  ping_pong: '\ued41',
  pinterest: '\ued42',
  pirate: '\ued43',
  pisces: '\ued44',
  pizza: '\ued45',
  places: '\ued46',
  plane_cloud: '\ued47',
  plane_front: '\ued48',
  plane: '\ued49',
  planet: '\ued4a',
  plant_open_book: '\ued4b',
  play_video_recording: '\ued4c',
  play: '\ued4d',
  playing_dice: '\ued4e',
  playing_gambling_cards: '\ued4f',
  pliers: '\ued50',
  plunger: '\ued51',
  png: '\ued52',
  podium: '\ued53',
  pointer_add: '\ued54',
  pointer_bank: '\ued55',
  pointer_bookmark: '\ued56',
  pointer_bowling: '\ued57',
  pointer_bus_station: '\ued58',
  pointer_delete: '\ued59',
  pointer_destination: '\ued5a',
  pointer_down: '\ued5b',
  pointer_favourite: '\ued5c',
  pointer_gas_station: '\ued5d',
  pointer_gym: '\ued5e',
  pointer_hospital: '\ued5f',
  pointer_jeweller: '\ued60',
  pointer_left_right: '\ued61',
  pointer_left: '\ued62',
  pointer_mechanic: '\ued63',
  pointer_restaurant: '\ued64',
  pointer_right: '\ued65',
  pointer_shopping: '\ued66',
  pointer_square_bookmark: '\ued67',
  pointer_square_hospital: '\ued68',
  pointer_up_down: '\ued69',
  pointer_up: '\ued6a',
  police_hat: '\ued6b',
  police_station: '\ued6c',
  pool: '\ued6d',
  pop_corn: '\ued6e',
  popping_champagne_drink: '\ued6f',
  portrait_photography_image: '\ued70',
  pot: '\ued71',
  potted_plant: '\ued72',
  power_button: '\ued73',
  power_of_writing: '\ued74',
  powerful_sword: '\ued75',
  previous: '\ued76',
  price_tag: '\ued77',
  printer_scatter_paper: '\ued78',
  printer: '\ued79',
  projector_modern: '\ued7a',
  projector: '\ued7b',
  protect_money: '\ued7c',
  protractor: '\ued7d',
  ps_vita: '\ued7e',
  psd: '\ued7f',
  pump: '\ued80',
  puppy: '\ued81',
  purse: '\ued82',
  putty_knife: '\ued83',
  pyramid: '\ued84',
  question_circle: '\ued85',
  question_love_heart: '\ued86',
  question_network: '\ued87',
  question_square_text: '\ued88',
  question_text: '\ued89',
  question_thought: '\ued8a',
  quill_writing_document: '\ued8b',
  quill_writing: '\ued8c',
  quill: '\ued8d',
  quotation: '\ued8e',
  quran: '\ued8f',
  r_circle: '\ued90',
  rabbit_in_the_hat: '\ued91',
  rabbit: '\ued92',
  rack_locked: '\ued93',
  rack_unlocked: '\ued94',
  rack: '\ued95',
  radiator: '\ued96',
  radio: '\ued97',
  railroad: '\ued98',
  railway: '\ued99',
  rain_cloud: '\ued9a',
  rain_storm: '\ued9b',
  rain: '\ued9c',
  rainbow: '\ued9d',
  ram: '\ued9e',
  ramen: '\ued9f',
  rar: '\ueda0',
  reach_goal: '\ueda1',
  read_message: '\ueda2',
  receipt: '\ueda3',
  record_movie_video_camera: '\ueda4',
  record: '\ueda5',
  recycle_bag: '\ueda6',
  recycle: '\ueda7',
  recycling_trash_bin: '\ueda8',
  red_eye: '\ueda9',
  reddit: '\uedaa',
  refresh_bitcoin: '\uedab',
  refresh_british_pound: '\uedac',
  refresh_circle: '\uedad',
  refresh_dollar: '\uedae',
  refresh_euro: '\uedaf',
  refresh_love_heart: '\uedb0',
  refresh_music_album: '\uedb1',
  refresh_network: '\uedb2',
  refresh_rotate_mobile_phone: '\uedb3',
  refresh_server: '\uedb4',
  refresh_thought: '\uedb5',
  refresh_webpage: '\uedb6',
  refresh_yen: '\uedb7',
  remote_control_car: '\uedb8',
  remote_control: '\uedb9',
  renewal_energy: '\uedba',
  resize: '\uedbb',
  resume: '\uedbc',
  retro_vintage_tv: '\uedbd',
  rewind: '\uedbe',
  rgb: '\uedbf',
  right: '\uedc0',
  ringing_notification_bell: '\uedc1',
  ringing_school_bell: '\uedc2',
  road_sign: '\uedc3',
  road: '\uedc4',
  robot: '\uedc5',
  rocket_take_off: '\uedc6',
  rocks: '\uedc7',
  roller_brush: '\uedc8',
  roller_skates: '\uedc9',
  room_armchair: '\uedca',
  room_couch: '\uedcb',
  room_drawers: '\uedcc',
  room_mirror_drawers: '\uedcd',
  room_phone: '\uedce',
  room_service: '\uedcf',
  rotate_circle: '\uedd0',
  round_arrow_down: '\uedd1',
  round_arrow_left: '\uedd2',
  round_arrow_right: '\uedd3',
  round_arrow_up: '\uedd4',
  round_bullet_points: '\uedd5',
  round_double_pointer_left: '\uedd6',
  round_double_pointer_right: '\uedd7',
  round_lines: '\uedd8',
  round_pointer_down: '\uedd9',
  round_pointer_left: '\uedda',
  round_pointer_right: '\ueddb',
  round_pointer_up: '\ueddc',
  round_texting: '\ueddd',
  round_tree: '\uedde',
  rounded_flower: '\ueddf',
  route: '\uede0',
  rss: '\uede1',
  ruler_left: '\uede2',
  ruler_right: '\uede3',
  safe: '\uede4',
  safety_helmet: '\uede5',
  sagittarius: '\uede6',
  sailing_boat_transportation: '\uede7',
  salad: '\uede8',
  salt: '\uede9',
  sand_digging: '\uedea',
  sandwich: '\uedeb',
  satellite_simple: '\uedec',
  satellite: '\ueded',
  save_storage_floppy_disk: '\uedee',
  saw: '\uedef',
  scale: '\uedf0',
  scarecrow: '\uedf1',
  scenery_compact_camera: '\uedf2',
  scenery_pictures: '\uedf3',
  schedule: '\uedf4',
  school_bell: '\uedf5',
  school_bus_front: '\uedf6',
  science_lab: '\uedf7',
  science_presentation: '\uedf8',
  science_test_tubes: '\uedf9',
  science: '\uedfa',
  scissors: '\uedfb',
  scooter: '\uedfc',
  scorpio: '\uedfd',
  screaming_alarm_clock: '\uedfe',
  screen: '\uedff',
  screwdriver: '\uee00',
  sd_card_search: '\uee01',
  sd_card: '\uee02',
  sea_window: '\uee03',
  search_bar_code: '\uee04',
  search_cars: '\uee05',
  search_circle: '\uee06',
  search_employee: '\uee07',
  search_for_professionals: '\uee08',
  search_house: '\uee09',
  search_internet_global: '\uee0a',
  search_internet: '\uee0b',
  search_love_heart: '\uee0c',
  search_love: '\uee0d',
  search_mobile_phone: '\uee0e',
  search_music_album: '\uee0f',
  search_network: '\uee10',
  search_server: '\uee11',
  search_square_text: '\uee12',
  search_storage: '\uee13',
  search_text: '\uee14',
  search_webpage: '\uee15',
  security_card: '\uee16',
  security_circle: '\uee17',
  security_code_confirmed: '\uee18',
  security_code_locked: '\uee19',
  security_code_unconfirmed: '\uee1a',
  security_credit_card: '\uee1b',
  security_house: '\uee1c',
  security_keyhole: '\uee1d',
  security_locked: '\uee1e',
  security_love_heart: '\uee1f',
  security_network: '\uee20',
  security_sd_card: '\uee21',
  security_server: '\uee22',
  security_shop: '\uee23',
  security_storage: '\uee24',
  security_webpage: '\uee25',
  segway: '\uee26',
  seperating_arrows: '\uee27',
  server: '\uee28',
  settings_thought: '\uee29',
  settings_two: '\uee2a',
  settings: '\uee2b',
  shaped_flower: '\uee2c',
  share_circle: '\uee2d',
  share_mobile_phone: '\uee2e',
  share_music_album: '\uee2f',
  share: '\uee30',
  sharp_music_note: '\uee31',
  shaver: '\uee32',
  shawerma: '\uee33',
  sheep: '\uee34',
  sheriff_badge: '\uee35',
  shield_ribbon: '\uee36',
  ship_captain: '\uee37',
  ship_front: '\uee38',
  ship: '\uee39',
  shipping_car: '\uee3a',
  shipping_ship: '\uee3b',
  shipping_time: '\uee3c',
  shipping: '\uee3d',
  shirt_and_tie: '\uee3e',
  shirt: '\uee3f',
  shishtawook: '\uee40',
  shoe_shop: '\uee41',
  shoe: '\uee42',
  shooting_rocket: '\uee43',
  shop: '\uee44',
  shopping_bag: '\uee45',
  shopping_basket: '\uee46',
  shopping_cart: '\uee47',
  short_monster: '\uee48',
  shorts: '\uee49',
  shovel: '\uee4a',
  shower_bathroom: '\uee4b',
  shower: '\uee4c',
  shuffle: '\uee4d',
  shuttle: '\uee4e',
  sign_left_direction: '\uee4f',
  sign_left_turn: '\uee50',
  sign_right_turn: '\uee51',
  sign_u_turn: '\uee52',
  sign_wrong_direction: '\uee53',
  sign: '\uee54',
  signal_employee: '\uee55',
  sim_card: '\uee56',
  siren: '\uee57',
  sketching: '\uee58',
  skirt: '\uee59',
  skull: '\uee5a',
  skype: '\uee5b',
  skyscrapers: '\uee5c',
  sleeved_dress: '\uee5d',
  sleeveless_dress: '\uee5e',
  slippers: '\uee5f',
  small_home: '\uee60',
  small_house: '\uee61',
  small_roof_house: '\uee62',
  smart_watch: '\uee63',
  smile_food: '\uee64',
  smiling_monster: '\uee65',
  smoke_detectors: '\uee66',
  smoking: '\uee67',
  sneakers: '\uee68',
  snorkle: '\uee69',
  snorkling: '\uee6a',
  snowflake_beautiful: '\uee6b',
  snowflake: '\uee6c',
  soccer: '\uee6d',
  sock: '\uee6e',
  soda_can: '\uee6f',
  solar_energy: '\uee70',
  sorting_arrows_up_down: '\uee71',
  sos: '\uee72',
  sound_proof: '\uee73',
  soundcloud: '\uee74',
  soup: '\uee75',
  space: '\uee76',
  spaceship: '\uee77',
  spades: '\uee78',
  spatchula: '\uee79',
  speaker: '\uee7a',
  speed_timer_lightening_bolt: '\uee7b',
  speedo: '\uee7c',
  speedometer: '\uee7d',
  split_arrows: '\uee7e',
  sports_team_tshirt: '\uee7f',
  spray_paint: '\uee80',
  sprayer: '\uee81',
  sprouting_plant: '\uee82',
  square_bullet_points: '\uee83',
  square_lines: '\uee84',
  square_pointer_down: '\uee85',
  square_pointer_left: '\uee86',
  square_pointer_right: '\uee87',
  square_pointer_up: '\uee88',
  square_texting: '\uee89',
  stamp_letter: '\uee8a',
  stamp: '\uee8b',
  standing_mixer: '\uee8c',
  standing_room_lamp: '\uee8d',
  star_fish: '\uee8e',
  star_medal: '\uee8f',
  star_ribbon: '\uee90',
  star_sleeping: '\uee91',
  star_trophy: '\uee92',
  starred_bookmark_favourite_house: '\uee93',
  start_button: '\uee94',
  steak: '\uee95',
  steering_wheel: '\uee96',
  stethescope: '\uee97',
  stop_watch: '\uee98',
  stop: '\uee99',
  stopwatch: '\uee9a',
  store: '\uee9b',
  strainer: '\uee9c',
  straps_dress: '\uee9d',
  strategy_plan: '\uee9e',
  strategy: '\uee9f',
  strawberry: '\ueea0',
  street_cone: '\ueea1',
  street_light: '\ueea2',
  street_lights: '\ueea3',
  street_sign: '\ueea4',
  street_view_arrows: '\ueea5',
  street_view_puppet: '\ueea6',
  sublet: '\ueea7',
  submarine: '\ueea8',
  suitcase_large: '\ueea9',
  suitcase_simple: '\ueeaa',
  suitcase: '\ueeab',
  sun_bright: '\ueeac',
  sun_cool: '\ueead',
  sun_hat: '\ueeae',
  sun_illuminated: '\ueeaf',
  sun_strong: '\ueeb0',
  sun: '\ueeb1',
  sunflower: '\ueeb2',
  sunglasses: '\ueeb3',
  sunlight_open_book: '\ueeb4',
  sunlight_solar_power: '\ueeb5',
  sunny: '\ueeb6',
  sunrise_sunset: '\ueeb7',
  sunscreen: '\ueeb8',
  surveillance: '\ueeb9',
  sushi: '\ueeba',
  swimming_pool: '\ueebb',
  swiss_army_knife: '\ueebc',
  swords_crossed_shield: '\ueebd',
  swords_crossed: '\ueebe',
  syringe: '\ueebf',
  tab_hold: '\ueec0',
  tab: '\ueec1',
  tabla: '\ueec2',
  table_chair_room_facilities: '\ueec3',
  tablet: '\ueec4',
  target_audience: '\ueec5',
  target: '\ueec6',
  taurus: '\ueec7',
  tazer: '\ueec8',
  tea_pot: '\ueec9',
  tea_with_bag: '\ueeca',
  tea: '\ueecb',
  'team-sports-top': '\ueecc',
  team: '\ueecd',
  teeth_cleaning: '\ueece',
  telephone_cable_port_internet: '\ueecf',
  telephone: '\ueed0',
  telescope: '\ueed1',
  'television-satellite': '\ueed2',
  television_drawers: '\ueed3',
  'temperature-zero': '\ueed4',
  temperature_fifty: '\ueed5',
  temperature_one_hundred: '\ueed6',
  temperature_seventy_five: '\ueed7',
  temperature_twenty_five: '\ueed8',
  temple_pyramid: '\ueed9',
  tennis: '\ueeda',
  tent: '\ueedb',
  terrace: '\ueedc',
  text_expand: '\ueedd',
  text_message_mobile_phone: '\ueede',
  textbook_line_chart: '\ueedf',
  textbook: '\ueee0',
  theatre: '\ueee1',
  thermometer_celsius: '\ueee2',
  thermometer_fahrenheit_temperature_fahrenheit: '\ueee3',
  three_dimensional_document: '\ueee4',
  three_eyed_monster: '\ueee5',
  ticket: '\ueee6',
  tie: '\ueee7',
  time_limited_schedule_calendar: '\ueee8',
  time_management: '\ueee9',
  time_thought: '\ueeea',
  time: '\ueeeb',
  timer_square_text: '\ueeec',
  timer_text: '\ueeed',
  tire_pressure: '\ueeee',
  toaster: '\ueeef',
  toilet_paper: '\ueef0',
  toilet: '\ueef1',
  tomato: '\ueef2',
  toolbox: '\ueef3',
  tooth_cancel: '\ueef4',
  tooth_confirm: '\ueef5',
  tooth_crown: '\ueef6',
  tooth_delete: '\ueef7',
  tooth_happy: '\ueef8',
  tooth_protection: '\ueef9',
  tooth_refresh: '\ueefa',
  tooth_sad: '\ueefb',
  tooth_shield: '\ueefc',
  tooth: '\ueefd',
  toothbrush: '\ueefe',
  torn: '\ueeff',
  touch_finger: '\uef00',
  touch_hold_timer_finger: '\uef01',
  touch_rectangle_screen: '\uef02',
  touch_tap: '\uef03',
  touch_touchpad: '\uef04',
  touch: '\uef05',
  tower: '\uef06',
  tractor: '\uef07',
  trade_mark_circle: '\uef08',
  traffic_light: '\uef09',
  train_car: '\uef0a',
  train_ticket: '\uef0b',
  train: '\uef0c',
  trash: '\uef0d',
  travel_bag: '\uef0e',
  tree_cypress: '\uef0f',
  tree: '\uef10',
  triangle_tree: '\uef11',
  triangle: '\uef12',
  triggers: '\uef13',
  tripod: '\uef14',
  trophy_achievement: '\uef15',
  trophy: '\uef16',
  truck_front: '\uef17',
  truck: '\uef18',
  trumpet: '\uef19',
  tshirt: '\uef1a',
  tulip: '\uef1b',
  tuna_can: '\uef1c',
  twenty_four_hour_arrow: '\uef1d',
  twitter_bird: '\uef1e',
  twitter: '\uef1f',
  'two-headed_wrench': '\uef20',
  txt: '\uef21',
  'u-turn': '\uef22',
  ui_design_cancel: '\uef23',
  ui_design_charts: '\uef24',
  ui_design_checklist_checkmark: '\uef25',
  ui_design_checklist: '\uef26',
  ui_design_choices: '\uef27',
  ui_design_confirm: '\uef28',
  ui_design_different_shaped_tabs: '\uef29',
  ui_design_double_round: '\uef2a',
  ui_design_error: '\uef2b',
  ui_design_four_starter_tabs: '\uef2c',
  ui_design_four_starter: '\uef2d',
  ui_design_hierarchy: '\uef2e',
  ui_design_home_page: '\uef2f',
  ui_design_image: '\uef30',
  ui_design_images_comment: '\uef31',
  ui_design_loading_percentage: '\uef32',
  ui_design_loading: '\uef33',
  ui_design_locked: '\uef34',
  ui_design_multiple_shapes_landscape: '\uef35',
  ui_design_multiple_shapes: '\uef36',
  ui_design_multiple_starter: '\uef37',
  ui_design_multiple_tabs: '\uef38',
  ui_design_music: '\uef39',
  ui_design_navigation_list: '\uef3a',
  ui_design_navigation: '\uef3b',
  ui_design_personal_profile: '\uef3c',
  ui_design_pie_chart: '\uef3d',
  ui_design_play_video: '\uef3e',
  ui_design_profile: '\uef3f',
  ui_design_round_main: '\uef40',
  ui_design_round: '\uef41',
  ui_design_search: '\uef42',
  ui_design_security: '\uef43',
  ui_design_shopping_list: '\uef44',
  ui_design_shuffle_through: '\uef45',
  ui_design_starter_tab: '\uef46',
  ui_design_starter: '\uef47',
  ui_design_text_comment: '\uef48',
  ui_design_title_text_signature: '\uef49',
  ui_design_title_text: '\uef4a',
  ui_design_triple_starter_align: '\uef4b',
  ui_design_triple_starter_landscape: '\uef4c',
  ui_design_triple_starter: '\uef4d',
  ui_design_unlocked: '\uef4e',
  ui_design_upload_cloud: '\uef4f',
  umbrella_beach: '\uef50',
  umbrella: '\uef51',
  unconfirmed_security: '\uef52',
  underline: '\uef53',
  unhappy_webpage: '\uef54',
  unlock_mobile_phone: '\uef55',
  unlock_sd_card: '\uef56',
  unlock_storage: '\uef57',
  unlock: '\uef58',
  unlocked_circle: '\uef59',
  unlocked_network: '\uef5a',
  unlocked_server: '\uef5b',
  unread_message: '\uef5c',
  up_down: '\uef5d',
  up_shopping_cart: '\uef5e',
  up: '\uef5f',
  upload: '\uef60',
  urine_sample: '\uef61',
  usb_stick: '\uef62',
  usb_wire: '\uef63',
  usb: '\uef64',
  user_man_circle: '\uef65',
  user_woman_circle: '\uef66',
  vacuum_cleaner: '\uef67',
  valentines_day: '\uef68',
  valuables_safe: '\uef69',
  van: '\uef6a',
  vase_flower: '\uef6b',
  vibration: '\uef6c',
  video_file: '\uef6d',
  video_message: '\uef6e',
  view_house: '\uef6f',
  view_music_album: '\uef70',
  view_webpage: '\uef71',
  view: '\uef72',
  vimeo: '\uef73',
  vines: '\uef74',
  vintage_bike: '\uef75',
  vintage_diving_mask_equipment: '\uef76',
  vintage_room_key: '\uef77',
  vinyl: '\uef78',
  violin: '\uef79',
  virgo: '\uef7a',
  visible: '\uef7b',
  vk: '\uef7c',
  vneck_tshirt: '\uef7d',
  voice_message: '\uef7e',
  volcano_eruption: '\uef7f',
  volleyball: '\uef80',
  volume: '\uef81',
  waiter_food_serving: '\uef82',
  wake_up_call: '\uef83',
  wall: '\uef84',
  wallet: '\uef85',
  wardrobe: '\uef86',
  warehouse: '\uef87',
  warning_sign: '\uef88',
  washing_machine: '\uef89',
  watch_list: '\uef8a',
  water_bottle: '\uef8b',
  water_drop: '\uef8c',
  water_dropping: '\uef8d',
  water_heater: '\uef8e',
  water_ice: '\uef8f',
  water_pipe: '\uef90',
  water_power_earth: '\uef91',
  water_tap: '\uef92',
  water_tower: '\uef93',
  water: '\uef94',
  watermelon: '\uef95',
  webcam: '\uef96',
  webpage_smiling: '\uef97',
  webpage: '\uef98',
  weight_loss_slimer_waist: '\uef99',
  weight_scale_standing: '\uef9a',
  weight_scale: '\uef9b',
  weight: '\uef9c',
  whale_tail_diving: '\uef9d',
  whale: '\uef9e',
  whatsapp: '\uef9f',
  wifi: '\uefa0',
  wind_direction: '\uefa1',
  wind_mill: '\uefa2',
  wind: '\uefa3',
  window: '\uefa4',
  windows_curtains: '\uefa5',
  winking_heart: '\uefa6',
  wireless_computer_screen: '\uefa7',
  wireless_internet_connection: '\uefa8',
  wireless_internet_router: '\uefa9',
  wireless_keyboard: '\uefaa',
  wireless_mouse: '\uefab',
  wireless: '\uefac',
  woman_add: '\uefad',
  woman_alert: '\uefae',
  woman_block: '\uefaf',
  woman_bookmark: '\uefb0',
  woman_cancel: '\uefb1',
  woman_confirm: '\uefb2',
  woman_delete: '\uefb3',
  woman_favourite: '\uefb4',
  woman_settings: '\uefb5',
  woman_upper_body: '\uefb6',
  woman_view: '\uefb7',
  woman: '\uefb8',
  womens_purse: '\uefb9',
  wooden_crate: '\uefba',
  wooden_wall: '\uefbb',
  wrap: '\uefbc',
  wrench: '\uefbd',
  wristwatch: '\uefbe',
  writing_book: '\uefbf',
  writing_document: '\uefc0',
  writing: '\uefc1',
  xylophone: '\uefc2',
  yen_coin: '\uefc3',
  yen_sign: '\uefc4',
  ying_yang: '\uefc5',
  youtube_clip: '\uefc6',
  zeplin: '\uefc7',
  zip: '\uefc8',
  zoom_in_fingers: '\uefc9',
  zoom_in_hand: '\uefca',
  zoom_out_circle: '\uefcb',
  zoom_out_fingers: '\uefcc',
  zoom_out_hand: '\uefcd',
  zoom_out: '\uefce',
};
